/* eslint-disable no-tabs */
/* eslint-disable indent */
let oauth = {
	methods: {
        isAuthenticated () {
            return this.$auth.check()
		},
		redirectIfAuthenticated (route) {
			if (this.isAuthenticated()) {
                if (route)
                    return this.$router.push({name: route})
				return this.$router.push({name: 'Home'})
			}
		},
		redirectIfNotAuthenticated () {
			if (!this.isAuthenticated()) {
				return this.$router.push({name: 'Login'})
			}
		},
        getUserData (type) {
            if (type)
                return this.$auth.user()[type]
            return this.$auth.user()
		},
		logout () {
			this.$auth.logout({
				makeRequest: true,
				success () {
					return this.$router.push({name: 'Login'})
				},
				error (e) {
					console.log(e)
				}
			});
		}
	}
};

export default oauth



// WEBPACK FOOTER //
// ./src/mixins/auth.js